<template>
  <div>
    <!-- edit route modal -->
    <modal
      name="edit-route-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-route
        :selectedRoute="selectedRoute"
        :isSaveAndProceedButtonVisible="false"
        title="UREDI TURU"
        @saveAndCloseButtonClicked="editRoute"
      />
    </modal>

    <!-- add route modal -->
    <modal
      name="add-route-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-route
        :selectedRoute="selectedRoute"
        :isSaveAndProceedButtonVisible="true"
        title="DODAJ TURU"
        @saveAndCloseButtonClicked="addRoute"
        @saveAndProceedButtonClicked="addRouteAndContinue"
      />
    </modal>

    <!-- delete route modal -->
    <modal
      name="delete-route-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <delete-item
        message="Da li zaista žekite da obrišete turu"
        title="OBRIŠI turu"
        :selectedItem="selectedRoute"
        @deleteButtonClicked="deleteRoute"
      />
    </modal>

    <!-- Title -->
    <h1 class="title has-text-success">Ture</h1>
    <h2 class="subtitle">Administracija tura u preduzeću</h2>
    <!-- Table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        searchFn: searchFunc,
        placeholder: 'Pretraži...',
      }"
      @on-row-dblclick="onRowDoubleClick"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'before'">
          <!-- edit icon -->
          <span class="icon has-text-info">
            <i
              class="fas fa-edit"
              v-show="props.row.isnew === false"
              @click="editRow(props.row)"
            >
              <font-awesome-icon icon="edit" />
            </i>
          </span>
          <!-- delete icon -->
          <span class="icon has-text-danger">
            <i
              class="fas fa-trash-alt"
              v-show="props.row.isnew === false"
              @click="deleteRow(props.row)"
            >
              <font-awesome-icon icon="trash-alt" />
            </i>
          </span>
          <!-- add new row button -->
          <button
            class="button is-info is-size-7"
            v-show="props.row.isnew === true"
            @click="addRow(props.row)"
          >
            Dodaj
          </button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import EditRoute from "../parts/EditRoute.vue";
import DeleteItem from "../parts/DeleteItem.vue";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import { RouteBack, RouteFront } from "../../models/route.js";

export default {
  components: {
    VueGoodTable,
    EditRoute,
    DeleteItem,
  },
  name: "Routes",
  data() {
    return {
      selectedRoute: RouteFront,
      editModalName: "",
      columns: [
        {
          label: "R.Br.",
          field: "ordinal",
          type: "number",
          sortable: false,
        },
        {
          label: "Naziv ture",
          field: "name",
          sortable: false,
        },
        {
          label: "Broj kartice",
          field: "text",
          sortable: false,
        },
        {
          label: "Akcije",
          field: "before",
          sortable: false,
        },
      ],
      rows: [],
    };
  },
  computed: {},
  mounted() {
    this.getRoutes();
  },
  methods: {
    searchFunc(row, col, cellValue, searchTerm) {
      if (typeof cellValue === "string" || cellValue instanceof String) {
        return cellValue.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (cellValue == null) {
        return true;
      }
    },
    getRoutes() {
      // get all departments with appropriate info
      UserService.getRoutes().then(
        (response) => {
          console.log(response);
          response.data.forEach((element) => {
            this.rows.push(new RouteFront(element));
          });
          // add "add" row
          this.rows.push({
            routeId: null,
            companyId: null,
            name: null,
            description: null,
            value: null,
            text: null,
            isnew: true,
          });
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );
    },
    resetUi() {
      this.rows = [];
    },
    editRow(rout) {
      this.selectedRoute = rout;
      this.editModalName = rout.name;
      this.$modal.show("edit-route-modal");
    },
    deleteRow(rout) {
      this.selectedRoute = rout;
      this.editModalName = rout.name;
      this.$modal.show("delete-route-modal");
    },
    addRow(rout) {
      this.selectedRoute = rout;
      this.editModalName = rout.name;
      this.$modal.show("add-route-modal");
    },
    onRowDoubleClick(params) {
      this.editRow(params.row);
    },
    editRoute(route) {
      let routeToEdit = new RouteBack(route);

      UserService.putRoute(routeToEdit).then(
        () => {
          // reload ui
          this.resetUi();

          this.getRoutes();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );
      this.$modal.hide("edit-route-modal");
    },
    deleteRoute() {
      let routeToDelete = new RouteBack(this.selectedRoute);

      UserService.deleteRoute(routeToDelete).then(
        () => {
          // reload ui
          this.resetUi();

          this.getRoutes();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );
      this.$modal.hide("delete-route-modal");
    },
    addRoute(route) {
      // create new route
      let newRoute = new RouteBack(route);
      newRoute.companyId = this.$store.state.general.companyId;

      // upload
      UserService.postRoute(newRoute).then(() => {
        // reload ui
        this.resetUi();

        this.getRoutes();

        this.$modal.hide("add-route-modal");
      });
    },
    addRouteAndContinue(route) {
      // create new route
      let newRoute = new RouteBack(route);
      newRoute.companyId = this.$store.state.general.companyId;

      // upload
      UserService.postRoute(newRoute).then(() => {
        // reload ui
        this.resetUi();

        this.getRoutes();
      });
    },
    collectErrorMessage(error) {
      let msg =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return msg;
    },
  },
};
</script>
